// import topicsDir from "../__topicsDir";

/**
 * events data
 * イベント一覧データ
 * @props {string} date 日時（YYYY-MM-DD\THH:mm）
 * @props {string} title タイトル（html）
 * @props {string} [href] リンクURL
 */
export default [
	// {
	// 	date: "2020-11-19T13:30",
	// 	title: "令和2年度在宅医療推進センター連絡協議会【WEB】",
	// 	href: `${topicsDir}/2020/11-001/`
	// }
];
